// extracted by mini-css-extract-plugin
export default {"header":"VslaMenu_header__Wb0cX","menuItem":"VslaMenu_menuItem__mijvD","icon":"VslaMenu_icon__SMFOf","subheader":"VslaMenu_subheader__tHMUm"};